import { render, staticRenderFns } from "./DocumentTitle.vue?vue&type=template&id=1a61ff60&scoped=true&"
import script from "./DocumentTitle.vue?vue&type=script&lang=js&"
export * from "./DocumentTitle.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTitle.vue?vue&type=style&index=0&id=1a61ff60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a61ff60",
  null
  
)

export default component.exports